<template>
  <div>
    <InventoryUnLockedTable v-show="activeKey===1" ref="unlockedTable" :inventoryStates="inventoryStates" @unlock="unlock"/>
    <InventoryLockedTable v-show="activeKey===2" ref="lockedTable" :inventoryStates="inventoryStates" @back="back"/>
  </div>
</template>

<script>
import InventoryUnLockedTable from '@/views/operation/inventory_lock/InventoryUnLockedTable.vue'
import InventoryLockedTable from '@/views/operation/inventory_lock/InventoryLockedTable.vue'
import { getEnums } from '@/utils/util'

export default {
  name: 'InventoryLock',
  components: { InventoryUnLockedTable, InventoryLockedTable },
  data() {
    return {
      activeKey: 1,
      inventoryStates: []
    }
  },
  created() {
    getEnums('InventoryState').then(result => {
      this.inventoryStates = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.unlockedTable.fetch()
    },
    unlock() {
      this.activeKey = 2
      this.$refs.lockedTable.fetch()
    }
  }
}
</script>